var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-drupal-view-filter-dropdown"},[_c('v-select',{attrs:{"multiple":true,"close-on-select":false,"options":_vm.computedItems,"reduce":item => item.code,"placeholder":_vm.label},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }